module.exports = __webpack_public_path__ + "static/media/ControlManifest.Input.e3900b72.xml";